import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SNIPPETS_QUERY_KEY} from "../queryKeys";

type DeleteSnippetVariables = {id: number};

const deleteSnippet = async ({id}: DeleteSnippetVariables): Promise<boolean> => {
  const response = await axiosReachInstance.delete<boolean, AxiosResponse<boolean>>(`/snippets/${id}`);
  return response.data;
};

export const useDeleteSnippet = (
  options?: BaseMutationOptions<boolean, DeleteSnippetVariables>
): BaseUseMutationResult<boolean, DeleteSnippetVariables> => {
  return useBaseMutation<boolean, DeleteSnippetVariables>(deleteSnippet, {
    ...options,
    prefixKeysToReset: () => [[SNIPPETS_QUERY_KEY]],
  });
};
